<template>
  <div class="nrbHero">
    <uhero
      :image="heroData.image"
      :title="heroData.title"
      :body="heroData.body"
    >
      <template v-slot:btn>
      </template>
      <div class="container">
        <div class="workshop-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile">
              {{ heroData.title }}
            </h3>
            <p class="workshop_desc_mobile">
              {{ heroData.body }}
            </p>
          </div>
        </div>
      </div>
    </uhero>
  </div>
</template>

<script>
export default {
  data() {
    return {
      heroData: {
        title: "Frequently Asked Questions",
        body: "",
        image: require("../../assets/images/nrb-cover.png")
      }
    };
  }
};
</script>
